import React from 'react'
import {HStack, VStack, Text} from '@chakra-ui/react'
import {FormattedMessage} from 'react-intl'
import PropTypes from 'prop-types'
import DisplayPrice from '../../../components/display-price'
import useMultiSite from '../../../hooks/use-multi-site'

const ProductSetCockpitTotal = ({product, ...rest}) => {
    const {site} = useMultiSite()
    return (
        <HStack justify="space-between" {...rest}>
            <VStack justify="start" alignItems="flex-start" spacing={0}>
                <Text textStyle="Regular 2XLarge">
                    <FormattedMessage id="global.total" defaultMessage="Total" />
                </Text>
                <Text textStyle="Regular Small">
                    <FormattedMessage
                        id="product_set_detail.cockpit.product-count"
                        defaultMessage="{totalProducts} products"
                        values={{totalProducts: product?.setProducts?.length}}
                    />
                </Text>
            </VStack>
            {!site?.isContentOnlySite && (
                <VStack alignItems="flex-end" spacing={0}>
                    <DisplayPrice size="xxl" product={product} />
                    <Text textStyle="Regular Small">
                        <FormattedMessage
                            id="global.taxes_included"
                            defaultMessage="tax included"
                        />
                    </Text>
                </VStack>
            )}
        </HStack>
    )
}

ProductSetCockpitTotal.propTypes = {
    product: PropTypes.object
}
export default ProductSetCockpitTotal
